import { unifiedDetermineArticleHeadingCount } from '@s1/core/utilities';
import toc from '../_toc';

/**
 * Hybrid Template JS
 *
 * @type {{titleHeight: hybridTemplate.titleHeight}}
 */

const hybridTemplate = {
  /**
   * Adjust the vertical placement of the first Content Sidebar Ad
   * for the Sticky position can change as the user scrolls
   * @returns void
   */
  contentAdOffsetTop: () => {
    // Do not run if not on Hybrid Template
    const mainHybrid = document.querySelector('.main--hybrid');
    if (!mainHybrid) {
      return;
    }

    // Setup Elements used for Height values to handle calculations
    const adSidebarTop = document.querySelector('.sidebar__ad-space--dfp-desktop-sidebar-top');
    const contentAdTop = document.querySelector(
      '.main--hybrid .content .content-section:nth-of-type(1) .content-section__ad',
    );
    const rootFontSize = parseFloat(window.getComputedStyle(document.body).getPropertyValue('font-size'));

    const sidebarAds = () => {
      // Calculate Offset
      const adSidebarTopOffset = adSidebarTop.getBoundingClientRect().bottom; // Top of Viewport to bottom of Top Ad
      const diffOffset = adSidebarTopOffset + rootFontSize * 2; // Content Area Top + Height of Top Most Sidebar Ad + 2rem
      if (adSidebarTopOffset > 0) {
        // Run this as long as first content Element has yet to cross the top of the viewport
        contentAdTop.style.setProperty('--contentAdOffsetTop', `${diffOffset}px`);
      }
    };

    document.addEventListener('load', sidebarAds); // update the placement when the rest of the resources has loaded
    document.addEventListener('scroll', sidebarAds);
  },

  setAdHeight: () => {
    // Do not run on non hybrid templates
    if (!document.querySelector('.main--hybrid')) {
      return;
    }

    const fixAdHeight = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.target.id.includes('dfp-desktop-sidebar-mid')) {
          if (entry.target.children.length > 0 && entry.target.children[0].children) {
            entry.target.style.height = `${entry.target.children[0].children[0].height}px`; // the height of the iframe
          }
        }
      });
    };

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0.25, 0.75], // run callback in multiple places to try and catch the ad loading
    };

    const observer = new IntersectionObserver(fixAdHeight, options);
    Array.from(document.querySelectorAll('.content-section__ad')).forEach((adContainer) => {
      observer.observe(adContainer);
    });
  },

  /**
   * Catch All function for the Content Ads on the Hybrid Template,
   * Simplify the call in the _main.js file
   */
  contentAds: () => {
    hybridTemplate.setAdHeight();
    hybridTemplate.contentAdOffsetTop();
  },
};

const hybrid = () => {
  toc();
  hybridTemplate.contentAds();
  unifiedDetermineArticleHeadingCount();
};

window.addEventListener('DOMContentLoaded', () => {
  hybrid();
});
